import { handleActions } from 'redux-actions';
import { setNotes } from 'actions/notes';

const initialState: any = { candidatesNotes: [] };

const reducer = handleActions(
  {
    [setNotes as any]: (state, action) => {
      return { ...state, candidatesNotes: action.payload };
    },
  },
  initialState
);

export default reducer;
